import classNames from "classnames"
import React, { useState } from "react"

import { useTranslation } from "@bounce/i18n"
import { Button } from "@bounce/web-components"

import { ReviewCard } from "../../../../components/Generic/Reviews/ReviewCard/ReviewCard"
import type { Review } from "../../../../utils/reviews"

export type ReviewsProps = {
  reviews?: Review[]
  className?: string
}

export const Reviews = ({ reviews = [], className }: ReviewsProps) => {
  const { t } = useTranslation("marketing-generic")
  const [numReviewsDisplayed, setNumReviewsDisplayed] = useState(6)

  const reviewsDisplayed = reviews.slice(0, numReviewsDisplayed)
  const hasMoreReviews = numReviewsDisplayed < reviews.length

  const loadMore = () => setNumReviewsDisplayed(num => num + 6)

  return (
    <section className={classNames("relative mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
      <h2 className="title2 text-black">{t("screen.reviews.reviewsListTitleV6", "Our customers say it best")}</h2>
      <p className="subtitle mt-2 text-neutral-800 md:mt-2.5 xl:mt-3">
        {t("screen.reviews.reviewsListDescription", "Millions of bags stored. 1M+ customers all over the world.")}
      </p>
      <div className="mt-14 grid grid-cols-1 gap-5 md:mt-16 md:grid-cols-2">
        {reviewsDisplayed.map(review => (
          <ReviewCard key={review.id} review={review} className="size-full pb-8 xl:pb-12" />
        ))}
      </div>
      {hasMoreReviews && (
        <footer className="mt-12 flex flex-row items-center justify-center md:mt-14">
          <Button as="button" variant="ghost" onClick={loadMore}>
            {t("screen.reviews.loadMore", "Load more")}
          </Button>
        </footer>
      )}
    </section>
  )
}
